module.exports = __webpack_public_path__ + "static/media/win-game.01a55605.png";